import { render, staticRenderFns } from "./ObserverCommonComponent.html?vue&type=template&id=1087e3de&"
import script from "./ObserverCommonComponent.js?vue&type=script&lang=js&"
export * from "./ObserverCommonComponent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports